// @flow

// import { getShop } from 'src/helpers';
// import { checkPremiumStore } from 'src/helpers/subscription-helper';
import { isFreemiumPlan } from 'src/helpers/subscription-v4-helper';
// import { store } from 'src/stores/store';
// import apiService from 'src/services/api-service';

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

// /**
//  * Get type support based on shopify plan name
//  */
// const getTypeSupport = () => {
//   if (!store) return 'undefined';

//   const currentState = store.getState();

//   const externalInfo = _.get(currentState, 'oauth.tenantApp.externalInfo', {});
//   const shopifyPlan = _.get(externalInfo, 'plan_name', '');

//   return shopifyPlan ? (shopifyPlan === 'shopify_plus' ? 'Plus' : 'Regular') : 'undefined';
// };

/**
 * Check for support shopify plus
 *
 * Need to support as shopify plus if the store status:
 *  - Shopify plus plan and subscribe from 30 June 2020 forward
 *  - Standart plan, subscribed plan 15 and up and subscribe from 30 June 2020 forward
 *
 * @param  {object} tenantApp
 *
 * @return {boolean}           support shopify plus or not (true | false)
 */
// const checkShopifyPlus = tenantApp => {
//   const { selectedPlan = '', chargeInfoActive = {}, externalInfo = '' } = tenantApp;
//   const activeStatus = _.get(chargeInfoActive, 'status', '');
//   const billingOn = _.get(chargeInfoActive, 'activated_on', 0);
//   const planName = _.get(externalInfo, 'plan_name', '');

//   if (!selectedPlan) return false;

//   const billingOnTimestamp = new Date(billingOn).getTime();
//   const checkPointTimestamp = new Date('2020-06-30').getTime();
//   if (
//     activeStatus !== 'active' ||
//     (planName === 'shopify_plus' && billingOnTimestamp < checkPointTimestamp) ||
//     (planName !== 'shopify_plus' &&
//       (_.includes(lowPlan, selectedPlan.replace('_discount', '')) ||
//         billingOnTimestamp < checkPointTimestamp))
//   ) {
//     return false;
//   }

//   return true;
// };

/**
 * Init Intercom chatbox
 * @param {} tenantApp
 */
export const initIntercom = (tenantApp, history) => {
  // Don't show intercom with freemium plan
  const isFreemium = isFreemiumPlan(tenantApp);
  if (isFreemium) {
    window.Intercom('shutdown');
    return;
  }

  const email = tenantApp.externalInfo?.email;

  // console.log(`initIntercom(${email}, ${INTERCOM_APP_ID}, ${JSON.stringify(tenantApp.intercom)})`);

  if (INTERCOM_APP_ID && email) {
    const { userId, token, createdAt } = tenantApp?.intercom || {};
    window.Intercom('boot', {
      app_id: INTERCOM_APP_ID,
      api_base: `https://${INTERCOM_APP_ID}.intercom-messenger.com`,
      user_id: userId,
      intercom_user_jwt: token,
      created_at: createdAt
    });

    return history.listen(() => {
      window.Intercom('update', { last_request_at: parseInt(new Date().getTime() / 1000) });
    });
  }
  return;
};

/**
 * Show chatbox
 */
export const showChatbox = () => {
  window.Intercom('show');
};
